/* eslint-disable react/jsx-curly-newline */
import { Breadcrumb } from 'components/Breadcrumb';
import { useState, useEffect } from 'react';
import { CgArrowRight } from 'react-icons/cg';
import { MdCheck } from 'react-icons/md';

import { useParams } from 'react-router-dom';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import {
  Modal,
  Button,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@grupoboticario/flora-react';
import { deleteFile } from 'services/openClaimService';
import UploadInput, { FilesCallback } from 'components/UploadInput';
import { Download } from 'components/Download';
import { useDispatch, useSelector } from 'react-redux';
import {
  getClaimByIdAction,
  getStatusActionsAction,
  getStepsByIdAction,
} from 'store/modules/claims/actions';
import { ApplicationState } from 'store/store.inteface';
import { sendFile } from 'utils/sendFile';
import { BROKER_ACTIONS } from 'utils/statusEnum';
import {
  Container,
  Content,
  Title,
  Card,
  Label,
  ModalText,
  ButtonWrapper,
  CircleStep,
  ModalTitle,
} from './styles';
import { Banner } from './Banner';

export function DischargeTerms() {
  const dispatch = useDispatch();
  const { statusActions } = useSelector(
    (state: ApplicationState) => state.claims,
  );

  const { id } = useParams();
  const history = useHistoryWithHost();
  const [dropFiles, setDropFiles] = useState([]);
  const [modalSair, setModalSair] = useState(false);
  const [modalEnviar, setModalEnviar] = useState(false);
  const [files, setFiles] = useState<FilesCallback[]>([]);
  const [loading, setLoading] = useState(false);
  const [isPartial, setIsPartial] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const { claimById } = useSelector((state: ApplicationState) => state.claims);

  const { stores, cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const stepClaimStatus = useSelector(
    (state: ApplicationState) => state.claims.stepsClaimStatus,
  );

  useEffect(() => {
    const partialPaid = stepClaimStatus.find(
      obj => obj.statusBroker === BROKER_ACTIONS.PaidProcessPP,
    );

    if (partialPaid) {
      setIsPartial(true);
    } else {
      setIsPartial(false);
    }
  }, [isPartial, stepClaimStatus]);

  const preventEvent = (e: any) => {
    e.preventDefault();
  };

  const fileDrop = (e: any) => {
    e.preventDefault();
    const dropedFiles = e.dataTransfer.files;
    if (dropedFiles?.length) {
      setDropFiles(dropedFiles);
    }
  };

  const sendFiles = async () => {
    setLoading(true);
    try {
      await sendFile(
        id,
        files,
        isPartial ? 'dischargeTermsPP' : 'dischargeTerms',
        cpId,
        claimById.franchise.code,
      );
      setModalEnviar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stores.length > 0) {
      dispatch(getClaimByIdAction(id));
      dispatch(getStatusActionsAction(id));
      dispatch(getStepsByIdAction(id));
    }
  }, [dispatch, id, stores]);

  useEffect(() => {
    setLoadingData(false);
    if (!statusActions.documentAction) {
      setLoadingData(true);
    }
  }, [statusActions]);

  return (
    <Container>
      <Breadcrumb color="light" claimNumber={statusActions.number} />
      <Content>
        <Title>
          <span>Termo de Quitação</span>
        </Title>
        <Label>
          <p>
            <CircleStep>1</CircleStep>
            Você recebeu um termo de quitação, baixe, analise com muita atenção
            e assine
            <Banner title="ATENÇÃO!">
              O termo de quitação deverá ser assinado pelo representante legal
              do PDV
            </Banner>
          </p>
          <p>
            <CircleStep>2</CircleStep>Após assinado escaneie ou tire uma foto do
            termo de quitação para nos enviar.
          </p>
        </Label>
        <Card>
          <div className="card-text">
            <Download
              loading={loadingData}
              uri={statusActions.fileAction?.url}
              filename={`Termo de Quitação - Sinistro #${statusActions.number}`}
              // eslint-disable-next-line prettier/prettier
              header={
                <span className="card-title">
                  <CircleStep>1</CircleStep> BAIXAR TERMO DE QUITAÇÃO
                </span>
                // eslint-disable-next-line prettier/prettier
              }
            />
          </div>
          <div
            onDragOver={preventEvent}
            onDragEnter={preventEvent}
            onDragLeave={preventEvent}
            onDrop={fileDrop}
            className="card-text"
          >
            <span className="card-title">
              <CircleStep>3</CircleStep> ENVIAR TERMO ASSINADO
            </span>
            <UploadInput
              idDoc="Termo de Quitacao"
              required
              dropFiles={dropFiles}
              hasLoadingFiles={false}
              callbackFunc={cFiles => setFiles(cFiles)}
              deleteFile={deleteFile}
            />
          </div>
        </Card>
        <ButtonWrapper>
          <Button
            className="sair"
            size="small"
            onClick={() => setModalSair(true)}
          >
            Sair
          </Button>
          <Button
            className="enviar"
            size="small"
            styleSemantic="success"
            onClick={sendFiles}
            disabled={!files.length || loading}
          >
            Enviar
            <CgArrowRight size={17} className="" />
          </Button>
        </ButtonWrapper>

        <Modal open={modalSair} onOpenChange={setModalSair}>
          <ModalContent size="small">
            <ModalCloseButton />
            <ModalHeader />
            <ModalBody>
              <ModalText>Deseja mesmo sair?</ModalText>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => history.goBack()}>Sim</Button>
              <Button
                styleSemantic="warning"
                onClick={() => setModalSair(false)}
              >
                Não
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal open={modalEnviar} onOpenChange={() => history.goBack()}>
          <ModalContent size="small">
            <ModalCloseButton />
            <ModalHeader />
            <ModalBody>
              <ModalText>
                <MdCheck />
                <ModalTitle>Dados enviados para análise.</ModalTitle>
                Você receberá avisos no status deste processo, fique de olho!
              </ModalText>
            </ModalBody>
            <ModalFooter>
              <Button styleSemantic="success" onClick={() => history.goBack()}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Content>
    </Container>
  );
}
